import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { ERROR_CODES } from 'src/shared/constants';
import { API_BASE_URI } from 'src/shared/constants';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly LoginUrl = API_BASE_URI + '/api/auth/authorize';
  private readonly LogoutUrl = API_BASE_URI + '/api/auth/logout';
  private readonly IsAuthenticatedUrl =
    API_BASE_URI + '/api/auth/isauthenticated';

  constructor(private http: HttpClient) {}

  isAuthenticated(): Observable<boolean> {
    return this.http.get<boolean>(this.IsAuthenticatedUrl);
  }

  logout(code?: string) {
    const { concurrentLogin } = ERROR_CODES;
    let url = this.LogoutUrl;

    if (code === concurrentLogin) {
      url += '?code=' + concurrentLogin;
    }

    window.location.href = url;
  }

  login() {
    window.location.href = this.LoginUrl;
  }
}
